var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6253 3.01858H11.9095L11.3186 1.83681C11.0635 1.32269 10.5385 0.998191 9.96457 1.00001H6.16542C5.59152 0.998191 5.06645 1.32269 4.81141 1.83681L4.22053 3.01858H1.50464C1.22594 3.01858 1 3.24452 1 3.52322C1 3.80193 1.22594 4.02786 1.50464 4.02786H2.51393V13.5614C2.51493 14.4273 3.21664 15.129 4.08256 15.13H12.0474C12.9133 15.129 13.6151 14.4273 13.6161 13.5614V4.02786H14.6253C14.9041 4.02786 15.13 3.80193 15.13 3.52322C15.13 3.24452 14.9041 3.01858 14.6253 3.01858ZM5.71427 2.28822C5.79923 2.11688 5.97418 2.00872 6.16542 2.0093H9.96457C10.1558 2.00872 10.3308 2.11688 10.4157 2.28822L10.7809 3.01858H5.34911L5.71427 2.28822ZM12.6068 13.5614C12.6063 13.8701 12.3562 14.1203 12.0474 14.1207H4.08256C3.77382 14.1203 3.52366 13.8701 3.52321 13.5614V4.02787H12.6068V13.5614Z",
    fill: "#7E7E7E",
    stroke: "#7E7E7E",
    strokeWidth: 0.433333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06499 6.04644C7.78629 6.04644 7.56035 6.27237 7.56035 6.55108V11.5975C7.56035 11.8762 7.78629 12.1021 8.06499 12.1021C8.3437 12.1021 8.56964 11.8762 8.56964 11.5975V6.55108C8.56964 6.27237 8.3437 6.04644 8.06499 6.04644Z",
    fill: "#7E7E7E",
    stroke: "#7E7E7E",
    strokeWidth: 0.433333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54178 6.04644C5.26308 6.04644 5.03714 6.27237 5.03714 6.55108V11.5975C5.03714 11.8762 5.26308 12.1021 5.54178 12.1021C5.82049 12.1021 6.04643 11.8762 6.04643 11.5975V6.55108C6.04643 6.27237 5.82049 6.04644 5.54178 6.04644Z",
    fill: "#7E7E7E",
    stroke: "#7E7E7E",
    strokeWidth: 0.433333
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5882 6.04644C10.3095 6.04644 10.0836 6.27237 10.0836 6.55108V11.5975C10.0836 11.8762 10.3095 12.1021 10.5882 12.1021C10.8669 12.1021 11.0928 11.8762 11.0928 11.5975V6.55108C11.0928 6.27237 10.8669 6.04644 10.5882 6.04644Z",
    fill: "#7E7E7E",
    stroke: "#7E7E7E",
    strokeWidth: 0.433333
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.5bf5dc97.svg";
export { ForwardRef as ReactComponent };